(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'react-emotion', 'styled-components', '../../svg'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('react-emotion'), require('styled-components'), require('../../svg'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.reactEmotion, global.styledComponents, global.svg);
    global.ContentColumn = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _reactEmotion, _styledComponents, _svg) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _react2 = _interopRequireDefault(_react);

  var _styledComponents2 = _interopRequireDefault(_styledComponents);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-flow: column nowrap;\n  background-color: ', ';\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-flow: column nowrap;\n  background-color: ', ';\n']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  flex-flow: column nowrap;\n  align-items: center;\n'], ['\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  flex-flow: column nowrap;\n  align-items: center;\n']);

  var Col = (0, _styledComponents2.default)('div')(_templateObject, function (props) {
    return props.theme.secondaryTone;
  });

  var LeftColWrapper = (0, _styledComponents2.default)('div')(_templateObject2);

  var getClasses = function getClasses() {
    var defaultClasses = 'col-md-12 col-lg-6';
    return defaultClasses;
  };

  var ContentColumn = function ContentColumn(_ref) {
    var children = _ref.children,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? function () {
      return window.history.back();
    } : _ref$onClick,
        leftAction = _ref.leftAction,
        rightAction = _ref.rightAction,
        className = _ref.className;
    return _react2.default.createElement(
      Col,
      { className: (0, _reactEmotion.cx)(getClasses(), className) },
      _react2.default.createElement(
        'div',
        {
          style: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'flex-start'
          }
        },
        leftAction || _react2.default.createElement(
          'a',
          { onClick: onClick, style: { padding: '1rem', marginLeft: '.5rem' } },
          _react2.default.createElement(_svg.BackArrow, null)
        ),
        rightAction
      ),
      _react2.default.createElement(
        LeftColWrapper,
        null,
        children
      )
    );
  };

  exports.default = ContentColumn;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/layout/ContentColumn.js
// module id = 758
// module chunks = 1